import { render, staticRenderFns } from "./LimitedWarranty.vue?vue&type=template&id=380c1294&scoped=true&"
import script from "./LimitedWarranty.vue?vue&type=script&lang=js&"
export * from "./LimitedWarranty.vue?vue&type=script&lang=js&"
import style0 from "./LimitedWarranty.vue?vue&type=style&index=0&id=380c1294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380c1294",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
